<template>
  <section>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 总览 -->
    <el-row :gutter="10" class="mgb-20">
      <el-col :span="6">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img1"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">5</span>单</p>
            <p>品牌类别</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img2"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">5</span>单</p>
            <p>当前库存总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img3"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">55</span>单</p>
            <p>回收站在途库存总数</p>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="grid-content">
          <el-image
            class="img"
            :src="img4"
            fit="cover"
          ></el-image>
          <div class="total">
            <p><span class="font36">125</span>单</p>
            <p>次品总数</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <btns @exec="exec"></btns>
    <div class="data-container scroll-table">
      <!-- 库存统计 -->
      <el-table
        :data="tableData"
        border
        class="mgt-18"
        style="width: 100%"
        @selection-change="tableSelectionChange"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="customerName" label="品牌">
        </el-table-column>
        <el-table-column prop="customerName" label="已出库存数次品数">
        </el-table-column>
        <el-table-column prop="customerName" label="当前库存数"> </el-table-column>
        <el-table-column prop="customerName" label="物流公司">
        </el-table-column>
        <el-table-column prop="customerName" label="发货时间">
        </el-table-column>
        <el-table-column prop="customerName" label="入库时间">
        </el-table-column>
        <el-table-column prop="customerName" label="状态"> </el-table-column>
        <el-table-column prop="customerStatus" label="操作">
          <template slot-scope="scope">
            <button type="danger">
              修改备注
            </button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        class="mgt-10 pd-0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.totalCount"
      > -->
      </el-pagination>
    </div>
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";
import Button from "../sys/button.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      searchForm: {
        totalCount: 0,
        current: 1,
        size: 10,
      },
      tableData: [],
      tableSelection: [],
      img1:require('../../img/次品总数.png'),
      img2:require('../../img/当前库存总数.png'),
      img3:require('../../img/回收站在途库存数.png'),
      img4:require('../../img/品牌类别.png'),
    };
  },
  created() {
    this.query();
  },
  methods: {
    handleSizeChange(v) {
      this.searchForm.size = v;
      this.query();
    },
    handleCurrentChange(v) {
      this.searchForm.current = v;
      this.query();
    },
    query() {
      //获取接口
      this.$api.stock
        .getHouseStockList({})
        .then((d) => {
          if (d.code == 200) {
            this.tableData = d.data;
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    tableSelectionChange(val) {
      this.tableSelection = val;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    add() {
      this.btnForm = {
        btnIcon: "",
        btnName: "",
        btnCode: "",
        sort: 0,
      };
      this.addORUpdateVisible = true;
    },
  },
};
</script>
<style scoped lang='less'>
.grid-content {
  display: flex;
  padding: 15px 10px;
  background-color: aliceblue;
  .img {
    width: 75px;
    height: 75px;
  }
  .total {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    flex: 1;
    padding-left: 10px;
  }
  p {
    margin: 0;
    display: flex;
    align-items: baseline;
  }
}
.font36 {
  font-size: 36px;
  margin-right: 5px;
}
.row {
  padding: 10px;
  min-height: 35px;
  box-sizing: border-box;
  border: 1px solid var(--table-border);
}
.flex1 {
  flex: 1;
  text-align: center;
}
.border-8e {
  border: 1px solid var(--table-border);
}
</style>